import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { convoAIStatelessApiURL } from '../../prebuilt/utils';
import { startStreamingResponse } from '../start-streaming-response';
import { getSupportedMarkdowns } from './utils/get-supported-markdown-from-schema';
import { streamResponseParser } from './utils/stream-response-parser';
var sanitizeUrl = function sanitizeUrl(url) {
  return url.replace(/[^\w\-/.:%?=]+/g, '');
};

/**
 * A function that will fetch the response from the Convo AI API.
 *
 * @see https://hello.atlassian.net/wiki/spaces/EDAI/pages/3416730365/API+Specs+assistance-service
 *
 * @param input The input to be sent to the Convo AI API.
 * @param customEndpoint A custom endpoint to use for the request instead of the default Convo AI endpoint. It could be
 * 											 a platform specific middleware that will forward the request to the Convo AI API.
 */
export var streamConvoAI = function streamConvoAI(input, customEndpoint) {
  return function promptRequest(requestOptions) {
    /**
     * If the current selection is the same as the full document we won't
     * send it to the backend as it will get it from the full document
     */

    var draft_selected_content = input.currentSelection;
    if ('draftSelectedContentOverride' in input && input.draftSelectedContentOverride) {
      draft_selected_content = input.draftSelectedContentOverride;
    } else if (input.fullDocument === input.currentSelection) {
      draft_selected_content = undefined;
    }
    var streamingResponseGenerator = startStreamingResponse(_objectSpread({
      endpoint: customEndpoint || convoAIStatelessApiURL,
      payload: JSON.stringify(_objectSpread(_objectSpread({}, 'customPrompt' in input && input.customPrompt ? {
        recipient_agent_named_id: 'editor_agent',
        agent_input_prompt: input.customPrompt
      } : {
        recipient_agent_named_id: 'editor_intent_agent'
      }), {}, {
        agent_input_context: {
          ai_session_id: input.aiSessionId,
          content_url: sanitizeUrl(input.currentUrl || document.location.href),
          writing_intent: input.intentSchemaId,
          draft_full_content: input.fullDocument,
          draft_selected_content: draft_selected_content,
          supported_markdown_nodes: getSupportedMarkdowns(input.editorSchema),
          input_mime_type: 'text/markdown',
          output_mime_type: 'text/markdown',
          locale: input.userLocale,
          product: requestOptions.product,
          transformation_subtype: 'transformationSubtype' in input && input.transformationSubtype ? input.transformationSubtype : undefined
        }
      }))
    }, requestOptions));
    return streamResponseParser({
      streamingResponseGenerator: streamingResponseGenerator,
      isConvoAI: true
    });
  };
};